import { Box, Typography } from "@mui/material";
import patterbackground from "../../../assets/pattern3.svg";

interface Props {
  step: 1 | 2;
}

export default function StepHeader({ step }: Props) {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${patterbackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        px: 4,
        py: 3,
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1, maxWidth: 320, mx: "auto" }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "28px 1fr 28px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: "background.paper",
              color: "#7B5648",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: "0.82rem",
              zIndex: 2,
            }}
          >
            1
          </Box>

          <Box
            sx={{
              position: "relative",
              height: "4px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "999px",
              overflow: "hidden",
              mx: "-1px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: step === 1 ? "50%" : "100%",
                backgroundColor: "background.paper",
                borderRadius: "999px",
                transition: "width 0.35s ease",
              }}
            />
          </Box>

          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: step >= 2 ? "#fff" : "transparent",
              color: step >= 2 ? "#7B5648" : "#fff",
              border: step < 2 ? "1.5px solid rgba(255,255,255,0.7)" : "none",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: "0.82rem",
              zIndex: 2,
            }}
          >
            2
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
          <Typography
            sx={{
              color: step === 1 ? "#fff" : "rgba(255,255,255,0.65)",
              fontSize: "0.78rem",
              fontWeight: step === 1 ? 700 : 400,
              textAlign: "center",
              ml: "-45px",
            }}
          >
            Personal Information
          </Typography>
          <Typography
            sx={{
              color: step === 2 ? "#fff" : "rgba(255,255,255,0.65)",
              fontSize: "0.78rem",
              fontWeight: step === 2 ? 700 : 400,
              textAlign: "center",
              mr: "-45px",
            }}
          >
            Commission Payment
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
